export const Z_INDEX = {
  onTop: 1,
  justAboveOnTop: 2,
  loading: 3,
  layoutHeader: 10,
  dropdownMenuContents: 10,
  fileUploadElement: 12,
  floatingBanner: 50,
  loadingWrapper: 100,
  /* NOTE: 플랜 비교표 내부 stacking. 표 컨테이너 안에서만 유효한 상대값이다.
     좌측 기능명 열 < 카테고리 헤더 < 플랜 헤더 < 좌상단 모서리 순으로 겹친다. */
  planMatrixStickyColumn: 1,
  planMatrixCategoryHeader: 2,
  planMatrixStickyHeader: 3,
  planMatrixStickyCorner: 4,
  planModalDimmer: 104,
  planModalContents: 105,
  planModalContainer: 106,
  rootModal: 151,
  /* NOTE: 모달 안에서도 떠야 하므로 rootModal보다 위. pds IconTooltip과 같은 값 */
  tooltip: 500,
  /* messageBox z-index */
  rootLayer: 1,
  /* NOTE: 임베드는 메시지박스(dot/팝오버)보다 아래에 깔려야 한다 */
  embedLayer: 2,
  /* NOTE: 뷰어 미리보기 슬라이드 안에 표시되는 Powered by 배지 */
  freeBadgeLayer: 2,
  messageBoxLayer: 3,
  blockLayer: 4,
  buttonLayer: 4,
  messageBox: 9999,
};
